import React, { useEffect, useState } from "react";
import { BarChart } from "@mui/x-charts/BarChart";
import axios from "axios";
import { io } from 'socket.io-client';
import './livecounts.css';

const port = process.env.REACT_APP_SERVER_PORT;

function CollegeWiseChart() {

  
  

  const [data, setData] = useState({
    xAxis: [{ scaleType: "band", data: [] }],
    series: [{ data: [] }],
  });

  // const formatXAxisLabels = (labels) => {
  //   return labels.map(label => {
  //     if (label.toLowerCase() === "management") {
  //       return "MANG";
  //     }
  //     if (label.length > 8) {
  //       return label
  //         .split(/\s+/)   //^a-zA-Z]+/)
  //         .map(word => word.charAt(0).toUpperCase()) 
  //         .join(''); 
  //     }
  //     return label; // Return the label as it is if its length is <= 8     
  //   });
  // };


  const formatXAxisLabels = (labels) => {
  return labels.map(label => {
    if (!label || typeof label !== "string") return "";

    const college=label.toLowerCase().trim();

    if (college === "management")  return "MANG";
  
    if (college === "aditya college of pharmacy" || college === "acop" || college === "acp") return "ACOP";

    if (college === "aditya polytechnic college" || college === "poly") return "Poly";
    
    if (college === "aditya college of engineering & technology" || college === "acet") return "ACET";
    
    if (college === "aditya university" || college === "aus") return "AUS";

    if (college === "admin" || college === "administration" || college === "campus operations") return "Campus Operations";

    if (label.length > 8) {
      return label
        .trim()
        .split(/\s+/)
        .filter(word => word.length > 0)
        .map(word => word[0].toUpperCase())
        .join("");
    }

    return label;
  });
};

  

  const [isLoading, setIsLoading] = useState(true); // Loading state



  // Fetch data function  
  const fetchData = () => {
    axios
      .get(`${port}/count-by-department?EventDate="YES"`)
      .then((response) => {
        console.log("Data fetched", response.data);
        setData(response.data);
        setIsLoading(false); // Set loading to false once data is fetched
      })
      .catch((e) => {
        console.log('Error fetching data', e);
        setIsLoading(false);
      });
  };

  // Extract xAxis data  const xAxisData = data.xAxis[0].data;
  
  // Format the xAxis labels
  const xAxisData = data.xAxis[0].data;
  const formattedXAxis = formatXAxisLabels(xAxisData);
  console.log(formattedXAxis);

  data.xAxis[0].data = formattedXAxis;

  useEffect(() => {
    // Fetch data initially
    fetchData();

    // Connect to the Socket.IO server
    const socket = io(port); // Connect to the server with the specified port

    // Listen for the "new-registration" event
    socket.on("new-registration", () => {
      console.log("New registration detected");
      fetchData(); // Re-fetch data on new registration
    });

    // Cleanup the socket connection on unmount
    return () => {
      socket.off("new-registration"); // Remove the listener
      socket.disconnect(); // Disconnect the socket
    };
  }, []); // Empty dependency array ensures this effect runs only once

  return (
    <div style={{ display: "flex", justifyContent: "center",alignItems:"center", flexDirection: "column" }}>
      <h4 className="chart-title" style={{ marginBottom: 20, alignSelf: "center", marginTop: 20 }}>
        School-Wise Count
      </h4>
      {isLoading ? (
        <p style={{ textAlign: "center" }}>Loading chart data...</p>
      ) : (
        <div className="barChartContainer">
          <BarChart
            xAxis={data.xAxis}
            series={data.series}
            slots={{
              axisTickLabel: (props) => {
                const text = props.text || props.formattedValue || props.children;
                if (text === "Campus Operations") {
                  return (
                    <text {...props} textAnchor="middle">
                      <tspan x={props.x} dy="-0.2em">Campus</tspan>
                      <tspan x={props.x} dy="1.2em">Operations</tspan>
                    </text>
                  );
                }
                return <text {...props}>{text}</text>;
              }
            }}
            margin={{ bottom: 70 }}
          />
        </div>

      )}
    </div>
  );
}

export default CollegeWiseChart;
